import {
  RecommendationsUI,
  Props as RecommendationsUIProps,
} from "./RecommendationsUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { Variant } from "../../types/types";
import { ensureIsActiveVariant } from "../../utils/product/ensureIsActive";
import { getNotifiableEventType } from "../AddToBasket/components/NotAvailable/NotAvailable";

export function Recommendations({
  product,
  configProps,
}: Pick<StandardProps, "product" | "configProps">) {
  const { variant, isSelected } = useVariant(product);
  const activeVariant = ensureIsActiveVariant(variant);
  const placementId = configProps?.placementId
    ? String(configProps.placementId)
    : "";
  const type = configProps?.type as RecommendationsUIProps["type"];
  const maxProductsPerPage = configProps?.maxProductsPerPage
    ? String(configProps.maxProductsPerPage)
    : "5";
  const allowRefresh = configProps?.allowRefresh ? "true" : "false";

  const hideForOOSAndNotifiable = configProps?.hideForOOSAndNotifiable;

  const pctOosRecommendationsThreshold = 100;

  const notifiableEventType =
    activeVariant &&
    activeVariant.customerNotifiableEvents &&
    getNotifiableEventType(activeVariant.customerNotifiableEvents);

  const isOutOfStock = (variant: Variant): boolean => {
    return (
      !variant.availability?.availableToOrder &&
      variant.availability?.unavailableReason === "outOfStock"
    );
  };

  const areOutOfStock = (variants: Variant[]): boolean => {
    const outOfStockVariantsCount = variants.filter((variant) =>
      isOutOfStock(variant),
    ).length;

    const outOfStockVariantsPercent = Number(
      (outOfStockVariantsCount / variants.length) * 100,
    );

    return outOfStockVariantsPercent >= pctOosRecommendationsThreshold;
  };

  function isVariantNotifiable(): boolean {
    return isSelected && !!notifiableEventType;
  }

  function areAllVariantsOutOfStock() {
    return product.variants ? areOutOfStock(product.variants) : false;
  }
  const oos = areAllVariantsOutOfStock();
  const noti = isVariantNotifiable();

  const hideRecsPanel = hideForOOSAndNotifiable ? oos || noti : false;

  return (
    !hideRecsPanel && (
      <RecommendationsUI
        placement={placementId}
        pimProductId={product.aliases.pimProductId}
        skuId={variant.aliases.skuId}
        maxProductsPerPage={maxProductsPerPage}
        allowRefresh={allowRefresh}
        type={type}
      />
    )
  );
}
